export default __webpack_public_path__ + "static/media/Group 8547.6b219c5e.png";